import { createWebsiteHeaderButtonFromLibrary } from 'src/editor/pages/website/create-website-header-button'
import LibraryElementEnum from 'client/enums/LibraryElementEnum'
import {
  CommonLibraryElementsStructuresCreator,
  CreatorArgs,
} from 'src/editor/shared/entities/common-library-elements-structures-creator'
import { WebsiteLibraryElementsCreator } from './website-library-elements-creator'

export class WebsiteLibraryElementsStructuresCreator extends CommonLibraryElementsStructuresCreator {
  constructor() {
    super(WebsiteLibraryElementsCreator)
  }

  protected [LibraryElementEnum.LibraryWebsiteHeaderButton](args: CreatorArgs) {
    return createWebsiteHeaderButtonFromLibrary({
      createButton: this.createElement[LibraryElementEnum.LibraryButton],
      ...args,
    })
  }
  // ------------------------------
  // NOTE: website entity structure creators
  // ------------------------------
  // protected [LibraryElementEnum.LibraryWebsiteForm](args: CreatorArgs) {
  //   return createDefaultEntityStructure(
  //     {
  //       createEntity: this.createElement.createWebsiteForm,
  //       ...args
  //     }
  //   )
  // }
  // ------------------------------
}
